// src/services/tokenFetcher/bscTokenFetcher.js
import secureFetch from '../../utils/secureFetch';

/**
 * Fetch tokens for a BSC wallet using the Moralis API.
 * Transforms the response to match the expected format in Wallet.js
 *
 * @param {string} walletAddress - The wallet address to query
 * @returns {Promise<Array>} - A promise that resolves to an array of token objects in the expected format
 */
export const fetchTokens = async (walletAddress) => {
  const API_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6ImMxZmIxMzNiLThjMWEtNDYzMi05YjU5LWNhNWI0YmMzYjIwZiIsIm9yZ0lkIjoiNDI1MTY2IiwidXNlcklkIjoiNDM3Mjg3IiwidHlwZSI6IlBST0pFQ1QiLCJ0eXBlSWQiOiJhMWQ3YjZkMC03NTc0LTQ1ZDEtOTZiNC0wMGM2NjU5NmZlNGQiLCJpYXQiOjE3NDU4NzkwMTYsImV4cCI6NDkwMTYzOTAxNn0.9Gl8TWkknMJ6ld3YPJ14XoskdXYBksytD7O9uxEJ0Vk"; // Replace with your Moralis API key
  
  try {
    const response = await secureFetch(
      `https://deep-index.moralis.io/api/v2/${walletAddress}/erc20?chain=bsc`,
      {
        headers: {
          "Accept": "application/json",
          "X-API-Key": API_KEY
        }
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    if (!data || !Array.isArray(data)) {
      console.error("Unexpected Moralis API response format:", data);
      return [];
    }
    
    // Transform the data to match our expected format
    return data.map(item => {
      return {
        token: {
          type: "ERC-20",
          address: item.token_address,
          name: item.name,
          symbol: item.symbol,
          decimals: parseInt(item.decimals, 10)
        },
        value: item.balance || "0",
        // Moralis doesn't provide USD value in the basic endpoint
        usdValue: "0", 
        price: "0"
      };
    });
    
  } catch (error) {
    console.error("Error fetching BSC tokens:", error);
    return [];
  }
};